import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";

import { fetchWithToken } from "../../../../interceptors/fetchInterceptor";

import { getDataIssuingCertificatesBySearchParams } from "../../../../redux/issuingCertificatesReducer/actionsIssuingCertificates";
import { getDataExchangeCertificatesBySearchParams } from "../../../../redux/exchangeCertificatesReducer/actionsExchangeCertificates";
import { getDataDuplicateCertificatesBySearchParams } from "../../../../redux/duplicateCertificatesReducer/actionsDuplicateCertificates";
import { getDataPrintCertificatesBySearchParams } from "../../../../redux/printCertificatesReducer/actionsPrintCertificates";
import { clearAccidentData } from "../../../../redux/TransportAccidentsReportReducer/actionsTransportAccidentsReport";

import {
  API_GET_EXPULSION_ORDER_FILE,
  MAIN_URL,
  PORT_FOR_TRAINING,
  API_GET_RECORD_TRAINED_USERS_LOGBOOK_FILE,
  PORT,
  API_GET_LOGBOOK_ADMINISTRATIVE_PROCEDURES_FILE,
  API_GET_FILE_FOR_PRINT_CARD_PRINT_CERTIFICATES,
  API_ISSUE_CERTIFICATE_BY_ID,
  API_GET_LICENSE_INFO_FOR_MODAL,
  API_PRINT_INSPECTOR_WORK_STAT,
  PORT_FOR_REPORT,
  API_UPDATE_LOGBOOK_ADMINISTRATIVE_PROCEDURES_FILE,
} from "../../../../constants/constants";

import styles from "./ToolBlock.module.css";

function ToolBlock({
  data,
  addAccess = true,
  editAccess = true,
  viewAccess = true,
  printAccess = true,
  additionalAccess = {},
  id,
  viewId,
  tableKey,
  appStatusId,
  setShow,
  addBtnDisIn,
  searchParams,
  selectedPage,
  propsForButtons = {},
  personType,
  handleData,
  selectedRowData,
  externalButtonSettings = undefined,
}) {
  const [openBtn, setOpenBtn] = useState(false);
  const [addBtn, setAddBtn] = useState(false);
  const [viewBtn, setViewBtn] = useState(false);
  const [editBtn, setEditBtn] = useState(false);
  const [printBtn, setPrintBtn] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = Number(Cookies.get("userId"));

  const pathName = window.location.pathname.slice(1);

  const buttonsNames = {
    openBtnText: "Просмотр РК",
    addBtnText: (() => {
      switch (true) {
        case window.location.pathname.includes("searchboatcard"):
          return "Выбрать";
        case window.location.pathname.includes("issuing-certificates/applicant-search"):
          return "Выбрать";
        case window.location.pathname.includes("transportaccidents"):
          return "Добавить";
        case window.location.pathname.includes("checksAndAudits"):
          return "Добавить";
        case window.location.pathname.includes("exchange-certificates"):
          return "Добавить заявление";
        case window.location.pathname.includes("duplicate-certificates"):
          return "Добавить заявление";
        default:
          return "Добавить заявление";
      }
    })(),
    viewBtnText: (() => {
      switch (true) {
        case window.location.pathname.includes("print-certificates"):
          return "Предпросмотр";
        default:
          return "Просмотр";
      }
    })(),
    editBtnText: (() => {
      switch (true) {
        case window.location.pathname.includes("transportaccidents") ||
          window.location.pathname.includes("knoweledge-test-record") ||
          window.location.pathname === "/smallboats" ||
          window.location.pathname.includes("app-knowledge-verification") ||
          window.location.pathname === "/certificates":
          return "Редактировать";
        case window.location.pathname.includes("techexamination/searchboatcard"):
          return "Выбрать";
        case window.location.pathname.includes("techexamination"):
          return "Повторное ТО";
        case window.location.pathname.includes("issuing-certificates"):
          return "Выдать";
        case window.location.pathname.includes("print-certificates"):
          return "Указать номер";
        case window.location.pathname.includes("exchange-certificates") ||
          window.location.pathname.includes("duplicate-certificates"):
          return "Выдать";
        default:
          return "Взять в работу";
      }
    })(),
    printBtnText: (() => {
      switch (true) {
        case window.location.pathname.includes("smallboats"):
          return "Поиск удостоверения";
        case window.location.pathname.includes("inspectorworkstat"):
          return "Экспортировать";
        default:
          return "Печать";
      }
    })(),
  };

  const handleButtonOpen = async () => {
    switch (true) {
      case pathName.includes("reginformationchanges/searchboatcard"): {
        navigate(`/smallboats/view/${id}`, {
          state: {
            mode: "view",
          },
        });
        break;
      }
      case pathName.includes("dupshipsticket/searchboatcard"): {
        navigate(`/smallboats/view/${id}`, {
          state: {
            mode: "view",
          },
        });
        break;
      }
      default:
        break;
    }
  };

  const handleButtonAdd = async () => {
    switch (true) {
      case pathName.includes("reginformationchanges/searchboatcard"): {
        const board = data.content.find((el) => el.id === id);
        if (board.historicalModified) {
          if (board.ownerType === 1) {
            navigate("/reginformationchanges/individual/add", {
              state: {
                idBoadCard: id,
                idTypeStatement: board.ownerType,
                additionalAccess: additionalAccess,
                modeView: "add",
              },
            });
          }
          if (board.ownerType === 2) {
            navigate("/reginformationchanges/entity/add", {
              state: {
                idBoadCard: id,
                idTypeStatement: board.ownerType,
                additionalAccess: additionalAccess,
                modeView: "add",
              },
            });
          }
        } else {
          handleData();
        }

        break;
      }
      case pathName.includes("reginformationchanges"): {
        navigate("searchboatcard", {
          state: { additionalAccess: additionalAccess },
        });
        break;
      }
      case pathName.includes("dupshipsticket/searchboatcard"): {
        if (selectedRowData.historicalModified) {
          navigate(`/dupshipsticket/add/${id}`, {
            state: {
              mode: "add",
            },
          });
        } else {
          handleData();
        }
        break;
      }
      case pathName.includes("dupshipsticket"): {
        navigate("searchboatcard");
        break;
      }
      case pathName.includes("provisioninformation"): {
        setShow(true);
        // navigate("addStatement");
        break;
      }
      case pathName.includes("smallboatsreg"): {
        setShow(true);
        break;
      }
      case pathName.includes("transportaccidents"): {
        dispatch(clearAccidentData());
        navigate("./add", {
          state: { mode: "add" },
        });
        setShow(true);
        break;
      }
      case pathName.includes("techexamination"): {
        navigate("searchboatcard", {
          state: { additionalAccess: additionalAccess },
        });
        break;
      }
      case pathName.includes("app-knowledge-verification"): {
        navigate("/app-knowledge-verification/add");
        break;
      }
      // case pathName.includes("issuing-certificates/applicant-search"): {
      //   navigate(`/issuing-certificates/add/${id}`);
      //   break;
      // }
      case pathName.includes("issuing-certificates/applicant-search"): {
        navigate(`/issuing-certificates/${personType === 1 ? "republican" : "international"}/add/${id}`);
        break;
      }
      case pathName.includes("issuing-certificates"): {
        navigate("./applicant-search");
        break;
      }
      case pathName.includes("checksAndAudits"): {
        navigate(`/checksAndAudits`, {
          state: { mode: "add" },
        });
        setShow(true);
        break;
      }
      case pathName.includes("exchange-certificates") || pathName.includes("duplicate-certificates"): {
        setShow(true);
        break;
      }
      default:
        break;
    }
  };
  const handleButtonView = async () => {
    switch (true) {
      case pathName === "certificates": {
        navigate(`./licenseId/view/${id}`);
        break;
      }
      case pathName.includes("reginformationchanges"): {
        navigate(`./statement/${id}`, {
          state: {
            modeView: "view",
            idStatement: id,
            idTypeStatement: data.content.find((el) => String(el.id) === String(id)).personType,
          },
        });
        break;
      }
      case pathName.includes("provisioninformation"): {
        navigate(`/provisioninformation/statement/${id}`, {
          state: {
            modeView: "view",
            idStatement: id,
            idTypeStatement: data.find((el) => String(el.id) === String(id)).personType,
          },
        });
        break;
      }
      case pathName.includes("dupshipsticket"): {
        navigate(`/dupshipsticket/view/${id}`, {
          state: { mode: "view" },
        });
        break;
      }
      case pathName.includes("smallboatsreg"): {
        navigate(`./view/${personType === 1 ? "individual" : "entity"}/${id}`, {
          state: { mode: "view" },
        });
        break;
      }
      case pathName.includes("smallboats"): {
        navigate(`./view/${id}`, {
          state: { mode: "view" },
        });
        break;
      }
      case pathName.includes("transportaccidents"): {
        navigate(`./accident/${id}`, {
          state: { mode: "view" },
        });
        break;
      }
      case pathName.includes("techexamination/searchboatcard"): {
        navigate(`/smallboats/view/${id}`, {
          state: { mode: "view" },
        });
        break;
      }
      case pathName.includes("app-knowledge-verification"): {
        navigate(`/app-knowledge-verification/view/${id}`);
        break;
      }
      // case pathName.includes("techexamination"): {
      //   navigate(`./${id}`, {
      //     state: { mode: "view" },
      //   });
      //   break;
      // }
      case pathName.includes("techexamination"): {
        navigate(`/techexamination/${personType === 1 ? "individual" : "entity"}/view/${id}`, {
          state: { mode: "view" },
        });
        break;
      }
      case pathName.includes("checksAndAudits"): {
        navigate(`/checksAndAudits`, {
          state: { mode: "view" },
        });
        setShow(true);
        break;
      }
      // case pathName.includes("issuing-certificates"): {
      //   navigate(`/issuing-certificates/view/${id}`);
      //   break;
      // }
      case pathName.includes("issuing-certificates"): {
        navigate(`/issuing-certificates/view/${id}`);
        break;
      }
      // case pathName.includes("exchange-certificates"): {
      //   navigate(`/exchange-certificates/view/${viewId}`);
      //   break;
      // }
      case pathName.includes("exchange-certificates"): {
        navigate(`/exchange-certificates/view/${viewId}`);
        break;
      }
      // case pathName.includes("duplicate-certificates"): {
      //   navigate(`/duplicate-certificates/view/${viewId}`);
      //   break;
      // }
      case pathName.includes("duplicate-certificates"): {
        navigate(`/duplicate-certificates/view/${viewId}`);
        break;
      }
      case pathName.includes("print-certificates"): {
        const result = data[0].vrowid;
        navigate(`/print-certificates/view/${result}`, {
          state: { data: data[0], mode: "view" },
        });
        break;
      }
      case pathName.includes("knoweledge-test-record"): {
        navigate(`/knoweledge-test-record/view/${id.split("/").join("-")}`, {
          state: { mode: "view", protocolNum: id, additionalAccess },
        });
        break;
      }
      default:
        break;
    }
  };

  const handleButtonEdit = async () => {
    switch (true) {
      case pathName === "certificates": {
        navigate(`./licenseId/edit/${id}`);
        break;
      }
      case pathName.includes("reginformationchanges"): {
        navigate(`./decisioncard/${id}`, {
          state: {
            mode: "view",
            idStatement: id,
            additionalAccess: additionalAccess,
          },
        });
        break;
      }
      case pathName.includes("provisioninformation"): {
        navigate(`/provisioninformation/decisioncard/${id}`, {
          state: {
            modeView: "view",
            idStatement: id,
            idTypeStatement: data.find((el) => String(el.id) === String(id)).personType,
            additionalAccess,
          },
        });
        break;
      }
      case pathName.includes("dupshipsticket"): {
        navigate(`./decisioncard/${id}`, {
          state: { mode: "view", additionalAccess },
        });
        break;
      }
      case pathName.includes("smallboatsreg"): {
        navigate(`./decisioncard/${id}`, {
          state: { mode: "view", additionalAccess: additionalAccess },
        });
        break;
      }
      case pathName.includes("smallboats"): {
        navigate(`./edit/${id}`, {
          state: { mode: "edit" },
        });
        break;
      }
      case pathName.includes("shipsticket"): {
        navigate(`./decisioncard/${tableKey}/${id}`, {
          state: { mode: "view", tableKey: tableKey, additionalAccess },
        });
        break;
      }
      case pathName.includes("transportaccidents"): {
        navigate(`./accident/${id}`, {
          state: { mode: "edit" },
        });
        break;
      }
      // case pathName.includes("techexamination/searchboatcard"): {
      //   navigate(`/techexamination/${id}`, {
      //     state: { mode: "add", additionalAccess },
      //   });
      //   break;
      // }
      case pathName.includes("techexamination/searchboatcard"): {
        if (selectedRowData.historicalModified) {
          navigate(`/techexamination/${personType === 1 ? "individual" : "entity"}/add/${id}`, {
            state: { mode: "add", additionalAccess },
          });
        } else {
          handleData();
        }

        break;
      }
      case pathName.includes("techexamination"): {
        navigate(`/techexamination/${personType === 1 ? "individual" : "entity"}/edit/${id}`, {
          state: { mode: "edit", additionalAccess },
        });
        break;
      }
      case pathName.includes("app-knowledge-verification"): {
        navigate(`/app-knowledge-verification/edit/${id}`);
        break;
      }
      case pathName.includes("knoweledge-test-record"): {
        navigate(`/knoweledge-test-record/edit/${id.split("/").join("-")}`, {
          state: { mode: "edit", protocolNum: id, additionalAccess },
        });
        break;
      }
      case pathName.includes("print-certificates"): {
        const result = data[0].vrowid;

        navigate(`/print-certificates/edit/${result}`, {
          state: { data: data[0], mode: "edit" },
        });
        break;
      }
      case pathName.includes("issuing-certificates"): {
        const request = await fetchWithToken(MAIN_URL + PORT + API_ISSUE_CERTIFICATE_BY_ID + id).catch(
          (err) => console.log(err),
        );
        if (request.status === 200) {
          const response = await request.text();
          dispatch(getDataIssuingCertificatesBySearchParams(searchParams, selectedPage));
        }
        break;
      }
      case pathName.includes("exchange-certificates"): {
        const request = await fetchWithToken(MAIN_URL + PORT + API_ISSUE_CERTIFICATE_BY_ID + id).catch(
          (err) => console.log(err),
        );
        if (request.status === 200) {
          const response = await request.text();
          dispatch(getDataExchangeCertificatesBySearchParams(searchParams, selectedPage));
        }
        break;
      }
      case pathName.includes("duplicate-certificates"): {
        const request = await fetchWithToken(MAIN_URL + PORT + API_ISSUE_CERTIFICATE_BY_ID + id).catch(
          (err) => console.log(err),
        );
        if (request.status === 200) {
          const response = await request.text();
          dispatch(getDataDuplicateCertificatesBySearchParams(searchParams, selectedPage));
        }
        break;
      }
      default:
        break;
    }
  };

  const handleButtonPrint = async () => {
    switch (true) {
      case pathName.includes("registeroftrainees"): {
        const paramsString =
          "ids=" + data.map((item) => item.id).join(",") + "&" + "section=" + searchParams.section;

        window.location.href =
          MAIN_URL + PORT_FOR_TRAINING + API_GET_EXPULSION_ORDER_FILE + "?" + paramsString;
        break;
      }
      case pathName.includes("record-trained-user-logbook"): {
        const paramsString =
          "ids=" + data.map((item) => item.id).join(",") + "&" + "programId=" + searchParams.trainingProgId;

        window.location.href =
          MAIN_URL + PORT_FOR_TRAINING + API_GET_RECORD_TRAINED_USERS_LOGBOOK_FILE + "?" + paramsString;
        break;
      }
      case pathName.includes("logbookAdministrativeProcedures"): {
        try {
          const updateResponse = await fetchWithToken(
            MAIN_URL + PORT + API_UPDATE_LOGBOOK_ADMINISTRATIVE_PROCEDURES_FILE,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            },
          );

          if (updateResponse.ok) {
            try {
              const getResponse = await fetchWithToken(
                MAIN_URL + PORT + API_GET_LOGBOOK_ADMINISTRATIVE_PROCEDURES_FILE,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(searchParams),
                },
              );

              if (!getResponse.ok) {
                throw new Error("Network response was not ok");
              }

              const blob = await getResponse.blob();
              const url = window.URL.createObjectURL(new Blob([blob]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "Журнал АП.xls");
              document.body.appendChild(link);
              link.click();
              link.parentNode.removeChild(link);
            } catch (error) {
              console.error("Error downloading the file:", error);
            }
          } else {
            throw new Error("Error updating the logbook");
          }
        } catch (error) {
          console.error("Error processing the requests:", error);
        }
        break;
      }
      case pathName.includes("print-certificates"): {
        async function print() {
          await fetchWithToken(
            MAIN_URL +
              PORT +
              API_GET_FILE_FOR_PRINT_CARD_PRINT_CERTIFICATES +
              `?appIds=${data.reduce(
                (acc, current) => (Boolean(acc) ? acc + "," + current.vrowid : current.vrowid),
                "",
              )}&statusId=${data[0].statusId}&appType=${data[0].appType}&licenseTypeId=${
                data[0].licenseTypeId
              }`,
          )
            .then((response) => response.blob())
            .then((blob) => {
              const fileName = `Печать удостоверений.pdf`;
              const blobUrl = URL.createObjectURL(blob);
              const downloadLink = document.createElement("a");
              downloadLink.href = blobUrl;
              downloadLink.download = fileName;

              downloadLink.click();
            })
            .catch((error) => {
              console.error("Ошибка при получении PDF-документа:", error);
            });
        }
        await print();
        dispatch(getDataPrintCertificatesBySearchParams(searchParams, selectedPage));
        break;
      }
      case pathName.includes("smallboats"): {
        const searchLicense = async () => {
          const request = await fetchWithToken(MAIN_URL + PORT + API_GET_LICENSE_INFO_FOR_MODAL + id);
          if (request.status === 200) {
            const response = await request.json();
            handleData(response);
          } else if (request.status === 404) {
            const invalidResponse = await request.json();
            handleData(invalidResponse);
          } else {
            handleData({ invalidRequest: true });
          }
        };
        searchLicense();
        break;
      }
      case pathName.includes("inspectorworkstat"): {
        const paramsString =
          "date1=" +
          searchParams.date1 +
          "&" +
          "date2=" +
          searchParams.date2 +
          "&" +
          "inspectors=" +
          searchParams.inspector.join(",");
        const request = await fetchWithToken(
          MAIN_URL + PORT_FOR_REPORT + API_PRINT_INSPECTOR_WORK_STAT + paramsString,
        );

        if (request.ok) {
          const formData = await request.formData();
          const fileXlsx = formData.get("excel");
          const fileUrl = URL.createObjectURL(fileXlsx);
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = fileXlsx.name;
          link.click();
        }

        break;
      }
      default:
        break;
    }
  };

  useEffect(() => {
    switch (true) {
      case pathName === "smallboats":
        setOpenBtn(false);
        setAddBtn(false);
        setViewBtn(true);
        setEditBtn(true);
        setPrintBtn(true);
        break;
      case pathName === "smallboatsreg":
        setOpenBtn(false);
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(true);
        break;
      case pathName === "checksAndAudits":
        setOpenBtn(false);
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(false);
        break;
      case pathName === "reginformationchanges":
        setOpenBtn(false);
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(true);
        break;
      case pathName === "reginformationchanges/searchboatcard":
        setOpenBtn(true);
        setAddBtn(true);
        setViewBtn(false);
        setEditBtn(false);
        break;
      case pathName === "shipsticket":
        setOpenBtn(false);
        setAddBtn(false);
        setViewBtn(false);
        setEditBtn(true);
        break;
      case pathName === "dupshipsticket":
        setOpenBtn(false);
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(true);
        break;
      case pathName === "dupshipsticket/searchboatcard":
        setOpenBtn(true);
        setAddBtn(true);
        setViewBtn(false);
        setEditBtn(false);
        break;
      case pathName === "provisioninformation":
        setOpenBtn(false);
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(true);
        break;
      case pathName === "transportaccidents":
        setOpenBtn(false);
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(true);
        break;
      case pathName === "techexamination":
        setOpenBtn(false);
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(true);
        break;
      case pathName === "techexamination/searchboatcard":
        setOpenBtn(false);
        setAddBtn(false);
        setViewBtn(true);
        setEditBtn(true);
        break;
      case pathName === "registeroftrainees":
        setOpenBtn(false);
        setAddBtn(false);
        setViewBtn(false);
        setEditBtn(false);
        setPrintBtn(true);
        break;
      case pathName === "record-trained-user-logbook":
        setOpenBtn(false);
        setAddBtn(false);
        setViewBtn(false);
        setEditBtn(false);
        setPrintBtn(true);
        break;
      case pathName === "app-knowledge-verification":
        setOpenBtn(false);
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(true);
        setPrintBtn(false);
        break;
      case pathName === "issuing-certificates":
        setOpenBtn(false);
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(true);
        setPrintBtn(false);
        break;
      case pathName === "issuing-certificates/applicant-search":
        setOpenBtn(false);
        setAddBtn(true);
        setViewBtn(false);
        setEditBtn(false);
        setPrintBtn(false);
        break;
      case pathName === "print-certificates":
        setOpenBtn(false);
        setAddBtn(false);
        setViewBtn(true);
        setEditBtn(true);
        setPrintBtn(true);
        break;
      case pathName === "exchange-certificates" || pathName === "duplicate-certificates":
        setOpenBtn(false);
        setAddBtn(true);
        setViewBtn(true);
        setEditBtn(true);
        setPrintBtn(false);
        break;
      case pathName === "logbookAdministrativeProcedures":
        setOpenBtn(false);
        setAddBtn(false);
        setViewBtn(false);
        setEditBtn(false);
        setPrintBtn(true);
        break;
      case pathName === "knoweledge-test-record":
        setOpenBtn(false);
        setAddBtn(false);
        setViewBtn(true);
        setEditBtn(true);
        setPrintBtn(false);
        break;
      case pathName === "certificates":
        setOpenBtn(false);
        setAddBtn(false);
        setViewBtn(true);
        setEditBtn(true);
        setPrintBtn(false);
        break;
      case pathName === "inspectorworkstat":
        setPrintBtn(true);
        break;
      default:
        break;
    }
  }, [pathName]);

  return (
    <div className={styles["buttons-block"]}>
      {openBtn && (
        <>
          <button
            id={`open`}
            title={buttonsNames.openBtnText}
            disabled={Boolean(!id)}
            className={styles["other-btn"]}
            onClick={handleButtonOpen}>
            <p className={styles.buttons_text}>{buttonsNames.openBtnText}</p>
          </button>
        </>
      )}
      {addBtn && addAccess && (
        <button
          id={`add`}
          title={buttonsNames.addBtnText}
          disabled={addBtnDisIn}
          className={styles["add-btn"]}
          onClick={handleButtonAdd}>
          <span className={styles["plus-icon"]}></span>
          <p className={styles.buttons_text}>{buttonsNames.addBtnText}</p>
        </button>
      )}
      {viewBtn && viewAccess && (
        <button
          id={"view"}
          title={buttonsNames.viewBtnText}
          disabled={!(Boolean(id) || propsForButtons.disabledButtonView)}
          // disabled={viewBtnDisIn}
          className={styles["other-btn"]}
          onClick={handleButtonView}>
          <p className={styles.buttons_text}>{buttonsNames.viewBtnText}</p>
        </button>
      )}
      {editBtn && editAccess && (
        <>
          <button
            id={`edit`}
            title={buttonsNames.editBtnText}
            disabled={(() => {
              if (!Boolean(id)) {
                if (window.location.pathname.includes("print-certificates")) {
                  return !propsForButtons.disabledButtonEdit;
                }
                return true;
              } else {
                switch (true) {
                  case window.location.pathname.includes("smallboatsreg") ||
                    window.location.pathname.includes("dupshipsticket"):
                    if (Number(appStatusId) === 1) {
                      if (selectedRowData.inspector === userId) {
                        return false;
                      } else return true;
                    } else return true;
                  case window.location.pathname.includes("reginformationchanges"):
                    if (Number(appStatusId) === 1) {
                      if (selectedRowData.inspector === userId) {
                        return false;
                      } else return true;
                    } else return true;
                  case window.location.pathname.includes("shipsticket"):
                    if (Number(appStatusId) === 3) {
                      if (selectedRowData.inspector === userId) {
                        return false;
                      } else return true;
                    } else return true;
                  case window.location.pathname.includes("transportaccidents"):
                    return appStatusId !== "Новое";
                  case window.location.pathname.includes("techexamination/searchboatcard"):
                    return false;
                  case window.location.pathname.includes("techexamination"):
                    return Number(appStatusId) !== 7;
                  case window.location.pathname.includes("knoweledge-test-record"): {
                    return propsForButtons.disabledButtonEdit;
                  }
                  case window.location.pathname.includes("issuing-certificates") ||
                    window.location.pathname.includes("exchange-certificates") ||
                    window.location.pathname.includes("duplicate-certificates"): {
                    if (selectedRowData.inspector === userId) {
                      return Number(appStatusId) === 3 ? false : true;
                    } else return true;
                  }
                  case window.location.pathname.includes("provisioninformation"): {
                    if (Number(appStatusId) !== 4) {
                      if (selectedRowData.inspector === userId) {
                        return false;
                      } else return true;
                    } else return true;
                  }
                  case window.location.pathname.includes("certificates"):
                    if (Number(appStatusId) === 1 || Number(appStatusId) === 2) {
                      return false;
                    } else return true;
                  case window.location.pathname.includes("app-knowledge-verification"): {
                    if (selectedRowData.inspector === userId) {
                      return false;
                    } else return true;
                  }
                  default:
                    break;
                }
              }
            })()}
            className={styles["other-btn"]}
            onClick={handleButtonEdit}>
            <p className={styles.buttons_text}>{buttonsNames.editBtnText}</p>
          </button>
        </>
      )}
      {printBtn && printAccess && (
        <button
          id={`print`}
          title={buttonsNames.printBtnText}
          className={styles["other-btn"]}
          onClick={handleButtonPrint}
          disabled={(() => {
            if (
              window.location.pathname.includes("print-certificates") ||
              window.location.pathname.includes("smallboats")
            )
              return propsForButtons.disabledButtonPrint;
            return !data.length > 0;
          })()}>
          <p className={styles.buttons_text}>{buttonsNames.printBtnText}</p>
        </button>
      )}
      {externalButtonSettings && externalButtonSettings.access && (
        <button
          id={`externalButton`}
          title={externalButtonSettings.btnText}
          className={styles["other-btn"]}
          disabled={externalButtonSettings.disabled}
          onClick={externalButtonSettings.handler}>
          <p className={styles.buttons_text}>{externalButtonSettings.btnText}</p>
        </button>
      )}
    </div>
  );
}

export default ToolBlock;
